<template>
  <div>
    <div class="tasksTop">
      <div class="topSeach">
        <div style="display: flex;flex-wrap: wrap">
          <div class="innerSearch">
            <el-select
              v-model="input_driver"
              filterable
              remote
              :remote-method="remoteMethod"
              @change="changeDriverHandle"
              placeholder="All">
              <el-option
                v-for="item in option_driver"
                :key="item.worker_id"
                :label="item.name"
                :value="item.worker_id">
              </el-option>
              <div slot="prefix" >
                Driver:
              </div>
              <div style="clear: both">
              </div>
            </el-select>
          </div>
          <div class="innerSearch">
            <el-select v-model="group_input"
                       filterable
                       remote
                       :remote-method="remoteGropuMethod"
                       @change="changeGroupHandle"
                       placeholder="All">
              <el-option
                v-for="item in group_option"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
              <div slot="prefix" >
                Group:
              </div>
              <div style="clear: both">
              </div>
            </el-select>
          </div>
          <div class="innerSearch">
            <el-select
              v-model="input_year"
              placeholder="All"
              @change="changeYearHandle"
            >
              <el-option
                v-for="item in option_year"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
              <div slot="prefix" >
                Year:
              </div>
              <div style="clear: both">
              </div>
            </el-select>
          </div>
          <div class="innerSearch cascader">
            <div class="innerTime from">
              <el-date-picker
                v-model="bus_start_time"
                type="date"
                :clearable="false"
                placeholder="Select a date"
                value-format="yyyy-MM-dd"
                @change="chooseDate"
              >
              </el-date-picker>
              <div class="slot">From:</div>
            </div>
          </div>
          <div class="innerSearch cascader">
            <div class="innerTime to">
              <el-date-picker
                v-model="bus_end_time"
                type="date"
                :clearable="false"
                placeholder="Select a date"
                value-format="yyyy-MM-dd"
                @change="chooseDate"
              >
              </el-date-picker>
              <div class="slot">To:</div>
            </div>
          </div>
        </div>
        <div>
          <div class="innerSearch">
            <el-button type="warning"
                       style="background: #ffc215; border: 1px solid #ffc215 !important"
                       round
                       @click="downloadBusHandle"
            >Download </el-button>
          </div>
        </div>
      </div>
    </div>
    <div style="margin: 15px 0;"></div>
    <div class="wage_table" v-loading="business_loading" v-if="busi_list_data.length>0">
      <div  :class="{ wage_scroll_box: wage_scoll_num >100}">
        <el-row v-if="wage_scoll_num >100">
          <el-col :span="3">
            <div class="grid-content bg-purple-dark">
              <el-row class="table_row" style="display: flex">
                <el-col style="text-align: left">
                  <div class="grid-content bg-purple line" style="display: flex">
                    <div class="worker_name_box">Driver’s name</div>
                  </div>
                  <div class="succ_fail_title">
                    <div class="inner_time"></div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="autoWidth">
            <div class="grid-content bg-purple-dark out_scroll_box box1">
              <el-row class="table_row time_title_table">
                <el-col >
                  <div style="white-space: nowrap;line-height: 65px;">
                    <div class="inner_time"
                         :style="{width: inner_auto_width *100 +'%'}" v-for="(item,index) in time_title"
                         :key="index"
                         style="white-space: nowrap;border-bottom: none">{{item.date}}</div>
                  </div>
                  <div class="succ_fail_title">
                    <div class="inner_time" style="border-bottom: none" :style="{width: inner_auto_width *100 +'%'}"  v-for="(item,index) in time_title" :key="index">
                      <div v-if="item.total_failure >-1" class="suc">S</div>
                      <div v-if="item.total_success >-1" class="fail">F</div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="fillWidth">
            <div class="grid-content bg-purple-dark">
              <el-row class="table_row">
                <el-col :span="8">
                  <div class="grid-content bg-purple line">Rate</div>
                  <div class="succ_fail_title"><div class="inner_time"></div></div>
                </el-col>
                <el-col :span="8"><div class="grid-content bg-purple line">Quan.</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple line">Total</div></el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            <el-row class="table_row" style="display: flex">
              <el-col style="text-align: left">
                <div class="grid-content bg-purple line" style="display: flex">
                  <div class="worker_name_box">Driver’s name</div>
                </div>
                <div class="succ_fail_title">
                  <div class="inner_time"></div>
                </div>
              </el-col>
            </el-row>
            <div v-for="(item,index) in busi_list_data" :key="index">
              <el-row  class="table_row">
                <el-col :span="3" style="text-align: left;display: flex">
                  <div class="worker_name_box">{{item.name}}</div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :span="autoWidth">
          <div class="grid-content bg-purple-dark out_scroll_box scroll_list_box">
            <el-row class="table_row time_title_table" id="middle_top">
              <el-col >
                <div style="white-space: nowrap;line-height: 65px;">
                  <div class="inner_time"
                       :style="{width: inner_auto_width *100 +'%'}" v-for="(item,index) in time_title"
                       :key="index"
                       style="white-space: nowrap;border-bottom: none">{{item.date}}</div>
                </div>
                <div class="succ_fail_title">
                  <div class="inner_time" style="border-bottom: none" :style="{width: inner_auto_width *100 +'%'}"  v-for="(item,index) in time_title" :key="index">
                    <div v-if="item.total_failure >-1" class="suc">S</div>
                    <div v-if="item.total_success >-1" class="fail">F</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div v-for="(item,index) in busi_list_data" :key="index">
              <el-row  class="table_row time_title_table  table_bottom " style="border-bottom: none">
                <el-col>
                  <div style="white-space: nowrap;">
                    <div class="inner_time"  :style="{width: inner_auto_width *100 +'%'}" v-for="(items,indexs) in item.time_data" :key="indexs" style="white-space: nowrap;">
                      <div>{{items.total_success}}</div>
                      <div>{{items.total_failure}}</div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :span="fillWidth">
          <div class="grid-content bg-purple-dark">
            <el-row class="table_row">
              <el-col :span="8">
                <div class="grid-content bg-purple line">Rate</div>
                <div class="succ_fail_title"><div class="inner_time"></div></div>
              </el-col>
              <el-col :span="8"><div class="grid-content bg-purple line">Quan.</div></el-col>
              <el-col :span="8"><div class="grid-content bg-purple line">Total</div></el-col>
            </el-row>
          </div>
          <div v-for="(item,index) in busi_list_data" :key="index">
            <el-row  class="table_row">
              <el-col :span="8" >
                  <span>{{item.rate}}</span>
<!--                </div>-->
              </el-col>
              <el-col :span="8"><div class="grid-content bg-purple">{{item.quan}}</div></el-col>
              <el-col :span="8"><div class="grid-content bg-purple">{{item.total}}</div></el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-else class="empty">
      <div>
        <img src="../assets/image/list_blank.png" alt="">
        <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
      </div>
    </div>

  </div>
</template>

<script>
import store from "@/store";
import {exportWageTasks, getWageDriverList, getWageLsit, updateWageLsit, uploadWage} from "@/api/wageReview";
import {Axios} from '@/axios/axios.js'
import {getGroupList} from "@/api/driver";

export default {
  name: "businessView",
  data(){
    return{
      group_option:[],
      group_input:'',

      business_loading:true,
      busi_list_data:'',

      bus_start_time:'',
      bus_end_time:"",
      upload_title:'',
      fillWidth:"9",
      autoWidth:"12",
      page:1,
      limit:10,
      total:2,
      uploadDialog:false,
      wage_loading:false,
      note_input:'',
      note_mes:'',
      noteDialog:false,
      search_name:'',
      checkedCities:[],
      input_driver:'',
      option_driver:[],
      search_option_driver:[],
      input_year:'',
      option_year:[],
      // input_date:'',
      // option_date:[],
      time_title:[],
      drivers:[],
      upload_driver:'',//单独上传司机时，需要对
    }
  },
  computed: {
    inner_auto_width() {
      if  (this.time_title.length<8){
        return 1/this.time_title.length;
      }else {
        return 0.1428
      }
    },
    wage_scoll_num(){
      return store.state.wage_scoll_num
    }
  },
  created() {
    getGroupList({page:1,limit:''}).then(res=>{
      this.group_option = res.data.data
      this.group_option.unshift({
        group_id:'',
        name:'All'
      })
      this.search_option_group = this.group_option
    })
    this.option_year = this.getYearFrom2021()
    this.calculateWeekRange()
    this.getWageDriverList()
    this.getWageListData()
    this.scrollFun()
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollFun,true);
  },
  methods:{
    downloadBusHandle(){
      exportWageTasks({
        start_time:this.bus_start_time,
        end_time:this.bus_end_time,
        worker_id:this.input_driver
      }).then(res=>{
       if (res.code == 200){
         this.download(res.data.file)
       } else {
         this.$message({
           type:'warning',
           message:res.msg
         })
       }
      })
    },
    download(url){
      const link = document.createElement('a')
      link.href = 'https://work.back.rapidi.ca/storage/' + url
      link.setAttribute('download', '文件名字' + Date.now() + '.xls') // 下载文件的名称及文件类型后缀
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) // 下载完成移除元素
    },
    calculateWeekRange() {
      let date = new Date();
      let currYear = date.getFullYear();
      let currMonth = date.getMonth();
      let currWeekDay = date.getDate();
      let currDate = date.getDay();
      let weekStartDate = new Date(
        currYear,
        currMonth,
        currWeekDay - currDate - 6
      );
      let weekEndDate = new Date(
        currYear,
        currMonth,
        currWeekDay - currDate
      );
      let startMonth = weekStartDate.getMonth() + 1;
      let startDate = weekStartDate.getDate();
      let endMonth = weekEndDate.getMonth() + 1;
      let endDate = weekEndDate.getDate();
      this.bus_start_time = `${currYear}-${startMonth}-${startDate}`
      this.bus_end_time = `${currYear}-${endMonth}-${endDate}`
      // console.log(`${startMonth}月${startDate}日-${endMonth}月${endDate}日`);
    },
    scrollFun() {
      //监听滚动事件，将scrollTop存储vuex 在wage 页面监听取用
      let scrollTop = document.getElementsByClassName('scroll_list_box')[0].scrollLeft;
      if (this.wage_scoll_num >110){
        document.getElementsByClassName('box1')[0].scrollLeft = scrollTop
      }
    },
    //获取从2021 到当前的年份
    getYearFrom2021(){
      const currentYear = new Date().getFullYear();
      this.input_year = currentYear
      const startYear = 2021;
      const years = [];
      for (let year = startYear; year <= currentYear; year++) {
        years.push(year);
      }
      return years;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    //修改年份时触发
    changeYearHandle(e){
      this.getWageListData()
      this.getWageDriverList()
    },
    showNoteHandle(row){
      // noteDialog
      this.noteDialog = true
      this.note_input = row.wage_note
      this.note_mes = row
    },
    //更新备注
    saveEditHandle(){
      this.noteDialog = false
      this.updataWageListHandle(this.note_mes)
    },
    updataWageListHandle(row){
      updateWageLsit({
        start_time:this.start_time,
        end_time:this.end_time,
        worker_id:row.worker_id,
        wage_note:this.note_input,
        rate:row.rate,
        bonus:row.bonus,
        adjust:row.adjust,
        HST:row.hst,
      }).then(res=>{
        if (res.code == 200){
          this.busi_list_data.forEach(v=>{
            if (v.worker_id == row.worker_id){
              v.basic = v.rate*v.quan
              v.basic = Math.round(Number(v.basic)  * 100) / 100;
              v.subtotal =Number(row.bonus ) +Number(row.adjust)  + Number(row.basic)
              v.subtotal = Math.round(Number(v.subtotal)  * 100) / 100;
              if (row.hst == 'Incl'){
                v.total =v.subtotal
                v.total = Math.round(Number(v.total)  * 100) / 100;
              }else if  (row.hst == 'Excl'){
                v.total =(Number(v.subtotal)*113)/100
                v.total = Math.round(Number(v.total)  * 100) / 100;
              }else {
                v.total = v.subtotal
                v.total = Math.round(Number(v.total)  * 100) / 100;
              }
              v.wage_note = this.note_input
            }
          })
          // this.getWageListData()
          this.$message({
            type:"success",
            message:res.msg
          })
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      })
    },
    getWageListData(){
      this.business_loading = true
      getWageLsit({
        page:this.page,
        limit:this.limit,
        start_time:this.bus_start_time,
        end_time:this.bus_end_time,
        worker_id:this.input_driver,
        group_id:this.group_input,
        table_type:1,
      }).then(res=>{
        this.business_loading =false
        if (res.code == 200){
          const obj = {}
          res.data.forEach(v=>{
            v.show_rate_input = false
            for (let key of Object.keys(v.data)) {
              if(!Object.prototype.hasOwnProperty.call(obj, key)) {
                obj[key] = v.data[key]
              }
            }
            v.time_data =obj
          })
          this.busi_list_data = res.data
          //需要正对不同司机的不同时间做数组对齐 比如a司机的时间1 有任务；b司机的时间2有任务，那么需要对a司机的时间2、b司机的时间1做空处理
          //这里选择遍历time_title对象，取time_title的key 跟每个司机中的data 做比较，如果不相等 则添加空；注意需要跟原本 0 项做区分
          const arrPrototype = Object.keys(obj)
          this.busi_list_data.forEach((item, index) => {
            for(let key of arrPrototype) {
              if (!Object.prototype.hasOwnProperty.call(item.data, key)){
                item.data[key] = {
                  total_failure:0,
                  total_success:0
                }
              }
            }
            let transformedData = [];
            for (const [date, values] of Object.entries(item.data)) {
              let transformedItem = { date, ...values };
              transformedData.push(transformedItem);
            }
            let sortedData = transformedData.sort((a, b) => {
              return arrPrototype.indexOf(a.date) - arrPrototype.indexOf(b.date);
            });
            item.time_data = sortedData
          })
          this.$nextTick(() => {
            this.time_title = this.busi_list_data[0]?.time_data
            console.log(this.time_title[0],this.busi_list_data[0]?.time_data)
            let length = this.time_title.length
            switch (length){
              case 1:
                this.autoWidth = 3
                this.fillWidth = 18
                break;
              case 2:
                this.autoWidth = 4
                this.fillWidth = 17
                break;
              case 3:
                this.autoWidth = 6
                this.fillWidth = 15
                break;
              case 4:
                this.autoWidth = 8
                this.fillWidth = 13
                break;
              case 5:
                this.autoWidth = 10
                this.fillWidth = 11
                break;
              case 6:
                this.autoWidth = 12
                this.fillWidth = 9
                break;
              case 7 :
                this.autoWidth = 12
                this.fillWidth = 9
                break;
            }
            if  (length >7){
              this.autoWidth = 12
              this.fillWidth = 9
            }
          })
          window.addEventListener("scroll", this.scrollFun,true);
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      }).catch(err=>{
        this.$message({
          type:"error",
          message:err
        })
      })
    },
    getWageDriverList(){
      getWageDriverList({
        start_time:this.start_time,
        end_time:this.end_time,
        name:this.search_name,
      }).then(res=>{
        if (res.code == 200){
          this.option_driver = res.data
          if  (this.option_driver.length >0){
            this.option_driver.unshift({
              worker_id:'',
              name:'All'
            })
          }
          this.search_option_driver = this.option_driver
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      })
    },
    handleCheckedCitiesChange(value){
      console.log(value,'value')
    },
    changeInputHandle(row,index){
      row.show_rate_input = true
      setTimeout(()=>{
        this.$refs['rate'+index][0].focus()
      })
      console.log(row,'dd')

    },
    showOutHandle(row){
      //如果input 为空 就恢复原来的值
      row.show_rate_input =false
      this.updataWageListHandle(row)
    },
    handleInput(v,item,type) {
      // 移除非数字和小数点以外的字符
      let sanitizedValue = v.replace(/[^\d.]/g, '');
      // 通过正则保留小数点后两位
      sanitizedValue = sanitizedValue.replace(/^(\d*\.\d{0,2}).*$/, '$1');
      // 更新输入框的值
      if (type == 'rate'){
        item.rate = sanitizedValue;
      }else {
        item.bonus = sanitizedValue;
      }
    },
    remoteMethod(val){
      this.search_name = val
      let arr = this. search_option_driver
      let result = arr.filter(item => item.name.includes(val));
      this.option_driver = result
    },
    remoteGropuMethod(val){
      let arr = this. search_option_group
      let result = arr.filter(item => item.name.includes(val));
      this.group_option = result
    },
    changeGroupHandle(){
      this.getWageListData()
      this.group_option = this.search_option_group
    } ,
    changeDriverHandle(val){
      console.log(val)
      this.getWageListData()
      this.option_driver = this.search_option_driver
    },
    chooseDate(){
      let t1 = this.bus_start_time
      let t2 = this.bus_end_time
      if (t1 && t2){
        if (new Date(t2).getTime()- new Date(t1).getTime()>= 14*1000*3600*24){
          this.$message({
            message: 'The maximum selection range is 14 days.',
            type: 'error',
          });
          this.bus_start_time = ''
          this.bus_end_time = ''
        }else {
          this.getWageListData()
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
.box1::-webkit-scrollbar-thumb {
  background: #ffffff;
  //height: 1px;
  visibility: visible;
}
.box1::-webkit-scrollbar {
  background: #ffffff;
  visibility: visible;

}
.scroll_list_box{
  //position: absolute;
}
.wage_scroll_box {
  position: fixed;
  top: 65px;
  z-index: 3;
  width: calc(100% - 264px);
  border-radius: 16px;
  background-color: #FFFFFF;
}
.empty {
  width: 200px;
  height: calc(100vh - 258px);
  margin: 20px auto;
  position: relative;
  img {
    width: 100%;
    height: 200px;
  }
  div {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
.tasksTop{
  padding: 8px;
  background: #FFFFFF;
  border-radius: 16px;
  border: 1px solid #E0E0E0;
  display: flex;
  justify-content: space-between;
  /deep/.changeFocus:focus{
    border: 1px solid #DCDFE6;
    color: #606266;
  }
  .topSeach{
    display: flex;
    justify-content: space-between;
    //flex-wrap: wrap;
    width: 100%;
    /deep/ .el-input--prefix .el-input__inner{
      padding-left: 88px;
    }
    /deep/ .el-input__prefix{
      color: #1F2D42;
    }
    .long_search{
      /deep/.el-input__inner{
        padding-left: 115px!important;
      }
    }
    .long_searchs{
      /deep/.el-input__inner{
        padding-left: 133px!important;
      }
    }
    .innerSearch{
      margin: 8px;
      /deep/.el-cascader{
        line-height: 0;
      }
      .innerTime{
        /deep/.el-input__prefix{
          position: absolute;
          top: 0;
          right: 12px;
          left: auto;
        }
        /deep/ .el-input--prefix .el-input__inner{
          padding-left: 12px;
        }
        /deep/.el-input__icon{
          //position: absolute;
          //right: 12px;
          color: #D65953;
        }
      }
      .from{
        /deep/.el-input__inner{
          padding-left: 75px!important;
        }
      }
      .to{
        /deep/.el-input__inner{
          padding-left: 55px!important;
        }
      }
    }
    .cascader{
      position: relative;
      /deep/.el-input__inner{
        padding-left: 80px;
      }
      .slot{
        position: absolute;
        padding-left: 24px;
        font-size: 14px;
        top: 5px;
      }
    }
    .ex{
      width: 300px;
      /deep/ .el-input--prefix .el-input__inner{
        padding-left: 110px;
      }
    }
  }

}
.wage_table{
  padding: 0 8px;
  background: #FFFFFF;
  border-radius: 16px;
  margin-top: 16px;

  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #1F2D42;
  line-height: 20px;
  .table_row{
    line-height: 64px;
    border-bottom: 1px solid #E0E0E0;
    .line{
      border-bottom: 1px solid #E0E0E0;
    }
    img{
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
    .red_point{
      position: absolute;
      top: -2px;
      right: 14px;
      width: 5px;
      height: 5px;
      background-color: #EB3F3F;
      border-radius: 50%;

    }
    .worker_name_box{
      white-space:nowrap;
      display: flex;
      margin-left: 16px;
    }
  }
  .time_title_table{
    text-align: left;
    .inner_time{
      text-align: center;
    }
  }
  .table_bottom{
    .inner_time{
      border-bottom: 1px solid #E0E0E0!important;
    }
  }
  .time_title_box{
    line-height: 20px;
    overflow-x: hidden;
  }
  .inner_time{
    display: inline-block;
    //width: 14.28%;
    div{
      width: 50%;
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
    }
  }
  .succ_fail_title{
    white-space: nowrap;
    //overflow-x: hidden;
    height: 28px;
    line-height: 28px;
    .inner_time{
      display: inline-block;
      //width: 14.28%;
      .suc{
        background-color: #82D237;
        width: 50%;
      }
      .fail{
        background-color: #E95646;
        width: 50%;
      }
      div{
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }

  .change_input{
    cursor: pointer;
    /deep/ .el-input__inner{
      text-align: center;
      border-radius: 10px;
    }
  }
  .out_scroll_box{
    width: 100%;
    overflow: auto;
    max-width: 100%;
  }
}
/deep/.el-col-2 {
  width: 5%;
}
/deep/.el-col-3{
  width: 11%;
}
/deep/.el-col-11 {
  width: 44.83333%;
}
/deep/.el-col{
  min-width: 40px;
}
.btomPagin{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  padding-left: 16px;
  .innerLeft{
    font-size: 16px;
    font-family: SFPro-Regular, SFPro;
    font-weight: 400;
    color: #1F2D42;
    line-height: 20px;
  }
}
.top_tabs{
  width: 322px;
  text-align: center;
  margin-bottom: 24px;
  /deep/.el-tabs__nav{
    background-color: #ECECF2!important;
    border-radius: 16px;
  }
  /deep/.el-tabs__header{
    margin: 0;
  }

  /deep/ .el-tabs__nav-scroll{
    padding-left: 0;
  }
  /deep/  .el-tabs__nav-wrap::after{
    background: none ;
  }
  /deep/  .el-tabs__item{
    height: 32px;
    line-height: 32px;
    flex: 1;
    padding-left: 0!important;
    padding-right: 0!important;
  }
  /deep/ .el-tabs__item.is-active{
    background: #E95646;
    color: #FFFFFF;
    border-radius: 16px;
  }
  /deep/.el-tabs__active-bar {
    background: none;
  }
}
</style>
